var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0028 36.2524L23.0913 65.0001L35.0028 55.4269L46.9111 65.0001L35.0028 36.2524Z",
    fill: "#86C4C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8848 35.8853L47.7931 64.636L49.4441 49.4446L64.6355 47.7936L35.8848 35.8853Z",
    fill: "#4B90A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2098 64.636L34.1182 35.8853L5.36743 47.7936L20.5589 49.4446L22.2098 64.636Z",
    fill: "#4B90A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1182 34.1184L22.2098 5.36768L20.5589 20.556L5.36743 22.2101L34.1182 34.1184Z",
    fill: "#4B90A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0028 33.7508L46.9111 5L35.0028 14.5731L23.0913 5L35.0028 33.7508Z",
    fill: "#86C4C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7931 5.36768L35.8848 34.1153L64.6355 22.2101L49.4441 20.556L47.7931 5.36768Z",
    fill: "#4B90A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7508 35.0001L5 23.0918L14.5763 35.0001L5 46.9085L33.7508 35.0001Z",
    fill: "#86C4C9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2522 35.0001L65.0029 46.9085L55.4267 35.0001L65.0029 23.0918L36.2522 35.0001Z",
    fill: "#86C4C9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9567 18.0502C54.8519 19.1551 53.0597 19.1551 51.9548 18.0502C50.85 16.9454 50.85 15.1532 51.9548 14.0484C53.0597 12.9435 54.8519 12.9435 55.9567 14.0484C57.0616 15.1532 57.0616 16.9454 55.9567 18.0502Z",
    fill: "#86C4C9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.804 37.8312C60.2409 37.8312 58.9729 36.5632 58.9729 35.0001C58.9729 33.437 60.2409 32.1689 61.804 32.1689C63.3671 32.1689 64.6352 33.437 64.6352 35.0001C64.6352 36.5632 63.3671 37.8312 61.804 37.8312Z",
    fill: "#4B90A6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9507 55.9536C50.8459 54.8487 50.8459 53.0565 51.9507 51.9517C53.0555 50.8468 54.8477 50.8468 55.9526 51.9517C57.0574 53.0565 57.0574 54.8487 55.9526 55.9536C54.8477 57.0584 53.0555 57.0584 51.9507 55.9536Z",
    fill: "#86C4C9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1711 61.8038C32.1711 60.2407 33.4392 58.9727 35.0023 58.9727C36.5654 58.9727 37.8334 60.2407 37.8334 61.8038C37.8334 63.3669 36.5654 64.6349 35.0023 64.6349C33.4392 64.6349 32.1711 63.3669 32.1711 61.8038Z",
    fill: "#4B90A6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0447 51.9517C15.1495 50.8468 16.9417 50.8468 18.0466 51.9517C19.1514 53.0565 19.1514 54.8487 18.0466 55.9536C16.9417 57.0584 15.1495 57.0584 14.0447 55.9536C12.9399 54.8487 12.9399 53.0565 14.0447 51.9517Z",
    fill: "#86C4C9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19734 32.1689C9.76043 32.1689 11.0285 33.437 11.0285 35.0001C11.0285 36.5632 9.76043 37.8312 8.19734 37.8312C6.63426 37.8312 5.36621 36.5632 5.36621 35.0001C5.36621 33.437 6.63426 32.1689 8.19734 32.1689Z",
    fill: "#4B90A6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0507 14.0454C19.1556 15.1503 19.1556 16.9425 18.0507 18.0473C16.9459 19.1521 15.1537 19.1521 14.0488 18.0473C12.944 16.9425 12.944 15.1503 14.0488 14.0454C15.1537 12.9406 16.9459 12.9406 18.0507 14.0454Z",
    fill: "#86C4C9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.83 8.19783C37.83 9.76092 36.5619 11.029 34.9989 11.029C33.4358 11.029 32.1677 9.76092 32.1677 8.19783C32.1677 6.63475 33.4358 5.3667 34.9989 5.3667C36.5619 5.3667 37.83 6.63475 37.83 8.19783Z",
    fill: "#4B90A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHc);
export default __webpack_public_path__ + "static/media/logoHC.6786e8695f408e21205a5a48e8b9ccd7.svg";
export { ForwardRef as ReactComponent };